import { api } from '../../../shared/api/client';
import {
  type ListEnvelope,
  normalizeListEnvelope,
  toGenexusParams,
} from '../../../shared/api/genexus-query';
import type { CrudApi } from '../../../shared/api/crud-hooks';
import type { DataTableQuery } from '../../../shared/components/DataTable';
import type { CargoDto, CargoInput, CargoListItem } from './types';

const BASE = '/v1/positions';

export const cargosApi: CrudApi<CargoListItem, CargoDto, CargoInput> = {
  async list(query: DataTableQuery): Promise<ListEnvelope<CargoListItem>> {
    const { data } = await api.get<{
      data: CargoListItem[];
      meta: { total: number; pagina?: number; porPagina?: number };
    }>(BASE, { params: toGenexusParams(query) });
    return normalizeListEnvelope(data);
  },

  async get(id: number): Promise<CargoDto> {
    const { data } = await api.get<{ data: CargoDto }>(`${BASE}/${id}`);
    return data.data;
  },

  async create(input: CargoInput): Promise<CargoDto> {
    const { data } = await api.post<{ data: CargoDto }>(BASE, input);
    return data.data;
  },

  async update(id: number, input: CargoInput): Promise<CargoDto> {
    const { data } = await api.put<{ data: CargoDto }>(`${BASE}/${id}`, input);
    return data.data;
  },

  async remove(id: number): Promise<void> {
    await api.delete(`${BASE}/${id}`);
  },
};
